<div class="kt-card max-w-[370px] w-full mx-auto">
  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="kt-card-content flex flex-col gap-5 p-10">
    <div class="text-center mb-2.5">
      <h3 class="text-lg font-medium text-mono leading-none mb-2.5">Sign in</h3>
      <div class="flex items-center justify-center font-medium">
        <span class="text-sm text-secondary-foreground me-1.5">Need an account?</span>
        <a class="text-sm link" routerLink="/auth/sign-up">Sign up</a>
      </div>
    </div>
    <div class="grid grid-cols-2 gap-2.5">
      <a class="kt-btn kt-btn-outline justify-center" href="javascript:void(0)">
        <img alt="" class="size-3.5 shrink-0" src="/assets/media/brand-logos/google.svg"/>
        Google
      </a>
      <a class="kt-btn kt-btn-outline justify-center" href="javascript:void(0)">
        <img alt="" class="size-3.5 shrink-0 dark:hidden" src="/assets/media/brand-logos/apple-black.svg"/>
        <img alt="" class="size-3.5 shrink-0 light:hidden" src="/assets/media/brand-logos/apple-white.svg"/>
        Apple
      </a>
    </div>
    <div class="flex items-center gap-2">
      <span class="border-t border-border w-full"></span>
      <span class="text-xs text-muted-foreground font-medium uppercase">Or</span>
      <span class="border-t border-border w-full"></span>
    </div>

    @if (errorMessage) {
      <div class="text-red-500 text-sm italic text-center">
        {{ errorMessage }}
      </div>
    }

    <div class="flex flex-col gap-1">
      <label class="kt-form-label font-normal text-mono">Username</label>
      <input class="kt-input" formControlName="username" placeholder="Username" type="text" 
             [ngClass]="{'border-red-500': loginForm.get('username')?.touched && loginForm.get('username')?.invalid}"/>
      @if (loginForm.get('username')?.touched && loginForm.get('username')?.invalid) {
        <span class="text-xs text-red-500 mt-1">Username is required</span>
      }
    </div>

    <div class="flex flex-col gap-1">
      <div class="flex items-center justify-between gap-1">
        <label class="kt-form-label font-normal text-mono">Password</label>
        <a class="text-sm kt-link shrink-0" routerLink="/auth/reset-password/enter-email">Forgot Password?</a>
      </div>
      <div class="kt-input" data-kt-toggle-password="true"
           [ngClass]="{'border-red-500': loginForm.get('password')?.touched && loginForm.get('password')?.invalid}">
        <input formControlName="password" placeholder="Enter Password" [type]="passwordVisible ? 'text' : 'password'"/>
        <button class="kt-btn kt-btn-sm kt-btn-ghost kt-btn-icon bg-transparent! -me-1.5"
                type="button" (click)="togglePasswordVisibility()">
          @if (!passwordVisible) {
            <span><i class="ki-filled ki-eye text-muted-foreground"></i></span>
          }
          @if (passwordVisible) {
            <span><i class="ki-filled ki-eye-slash text-muted-foreground"></i></span>
          }
        </button>
      </div>
      @if (loginForm.get('password')?.touched && loginForm.get('password')?.invalid) {
        <span class="text-xs text-red-500 mt-1">Password is required</span>
      }
    </div>

    <label class="kt-label">
      <input class="kt-checkbox kt-checkbox-sm" formControlName="rememberMe" type="checkbox"/>
      <span class="kt-checkbox-label">Remember me</span>
    </label>
    
    <button [disabled]="isLoading" class="kt-btn kt-btn-primary flex justify-center grow" type="submit">
      @if (!isLoading) {
        <span>Sign In</span>
      } @else {
        <span>Verifying...</span>
      }
    </button>
  </form>
</div>
